import { Controller } from "@hotwired/stimulus"

// Implicit-but-transparent Mixing tier (client 2026-09-02): the track count picks the
// package (track_min/track_max bounds from ServicePackage). The matching tier card + its add-on
// options group (both server-rendered, keyed by data-package-id) are revealed; hidden options are
// unchecked so they never submit. The hidden service_package_id is a UI convenience only — the
// server re-derives the package from the track count and never trusts the submitted id.
export default class extends Controller {
  static targets = ["input", "package", "tier", "options"]
  static values = { packages: Array }

  connect() { this.update() }

  update() {
    const count = parseInt(this.inputTarget.value, 10)
    const pkg = Number.isFinite(count) && count > 0
      ? this.packagesValue.find((p) =>
          (p.track_min == null || count >= p.track_min) && (p.track_max == null || count <= p.track_max))
      : null

    if (this.hasPackageTarget) this.packageTarget.value = pkg ? pkg.id : ""
    this.tierTargets.forEach((card) => { card.hidden = !pkg || card.dataset.packageId !== String(pkg.id) })
    this.optionsTargets.forEach((group) => {
      const match = pkg && group.dataset.packageId === String(pkg.id)
      group.hidden = !match
      if (!match) group.querySelectorAll("input[type=checkbox]").forEach((cb) => (cb.checked = false))
    })
  }
}
